import { useTranslation } from 'react-i18next';
import { useRecoveryService } from 'app/utils/services/recoveryService';
import { useSearchParams } from 'react-router-dom';
import { useGenerateTokenService } from 'app/utils/services/generateTokenService';
import logger from 'app/utils/logger';
import { useEffect } from 'react';
import { useGetOtpService } from 'app/utils/services/otpService';
import useRedirectWithFormId from 'app/utils/customHooks/useRedirectWithFormId';

const useLinkConfirm = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const ref = searchParams.get('key');

  const { dataRecovery, recoveryMutation } = useRecoveryService();
  const { isLoadingToken, dataToken, errorToken, tokenMutation } = useGenerateTokenService();
  const { isLoadingGetOtp, dataGetOtp, getOtpMutation } = useGetOtpService();
  const { handleRedirect } = useRedirectWithFormId();

  useEffect(() => {
    tokenMutation('az');
  }, []);

  useEffect(() => {
    if (dataToken !== undefined) {
      recoveryMutation({
        data: { reference: ref },
        url: '/api-web/v1/main/confirm_email',
      });
    }
  }, [dataToken]);

  useEffect(() => {
    if (dataGetOtp?.form_id === 'otp') {
      handleRedirect(dataGetOtp);
    }
  }, [dataGetOtp]);

  const handleConfirm = () => {
    getOtpMutation(dataRecovery?.business_key);
  };

  return { t, handleConfirm };
};

export default useLinkConfirm;
